import { useEffect } from 'react';

// Freeze the page behind an open modal.
//
// Setting `document.body.style.overflow = 'hidden'` is the usual trick, but it
// only works while <html> has `overflow: visible` — the body's value propagates
// to the viewport. Our index.css sets `html { overflow-x: clip }` (to kill
// horizontal overflow), which stops that propagation, so the page kept
// scrolling behind modals. Lock <html> itself instead.
//
// Hiding the scrollbar also widens the page by its width, which makes the
// content jump sideways; padding <html> by that amount holds it still.
// Nested modals are fine: each restores the inline values it replaced.
export function lockScroll() {
  const html = document.documentElement;
  const prev = {
    overflowY: html.style.overflowY,
    paddingRight: html.style.paddingRight,
    bodyOverflow: document.body.style.overflow,
  };
  const scrollbar = window.innerWidth - html.clientWidth;

  html.style.overflowY = 'hidden';
  if (scrollbar > 0) html.style.paddingRight = `${scrollbar}px`;
  document.body.style.overflow = 'hidden';

  return () => {
    html.style.overflowY = prev.overflowY;
    html.style.paddingRight = prev.paddingRight;
    document.body.style.overflow = prev.bodyOverflow;
  };
}

// `active` lets a component mount the hook unconditionally (hooks rules) and
// still lock only while its modal is open.
export function useScrollLock(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    return lockScroll();
  }, [active]);
}
